/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Savelocation1Inputs */

const en_savelocation1 = /** @type {(inputs: Savelocation1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save Location`)
};

const de_savelocation1 = /** @type {(inputs: Savelocation1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standort speichern`)
};

/**
* | output |
* | --- |
* | "Save Location" |
*
* @param {Savelocation1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const savelocation1 = /** @type {((inputs?: Savelocation1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Savelocation1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_savelocation1(inputs)
	return de_savelocation1(inputs)
});
export { savelocation1 as "saveLocation" }